import { render } from "./SpecialitiesSectionView.vue?vue&type=template&id=7b81b61d&scoped=true"
import script from "./SpecialitiesSectionView.vue?vue&type=script&lang=js"
export * from "./SpecialitiesSectionView.vue?vue&type=script&lang=js"

import "./SpecialitiesSectionView.vue?vue&type=style&index=0&id=7b81b61d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b81b61d"]])

export default __exports__